import { type MCPServerInfo } from '../../types';

const ChemblServer: MCPServerInfo = {
  serverId: 'CHEMBL',
  name: 'ChEMBL',
  slug: 'chembl',
  description:
    "A comprehensive Model Context Protocol (MCP) server providing advanced access to the ChEMBL chemical database. This server offers 27 specialized tools enabling AI assistants and MCP clients to perform sophisticated drug discovery research, chemical informatics analysis, and bioactivity investigations directly through ChEMBL's REST API.",
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/Augmented-Nature/ChEMBL-MCP-Server.git',
    commitSha: 'main',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  deprecated: true
};

export default ChemblServer;
